import React, { useState, useEffect } from "react";
import { agentApi } from "../../services/agentApi";

export default function PlaybookFaqEditor({ playbook, readOnly = false }) {
  const [items, setItems] = useState(Array.isArray(playbook.faqContent) ? playbook.faqContent : []);

  useEffect(() => {
    setItems(Array.isArray(playbook.faqContent) ? playbook.faqContent : []);
  }, [playbook.id]);

  function update(i, key, val) {
    const next = [...items];
    next[i] = { ...next[i], [key]: val };
    setItems(next);
  }
  function add() { setItems([...items, { question: "", answer: "" }]); }
  function remove(i) { setItems(items.filter((_, idx) => idx !== i)); }

  async function save() {
    try {
      await agentApi.playbooks.patch(playbook.id, { faqContent: items });
      alert("Salvo!");
    } catch (err) {
      alert(`Erro: ${err.message}`);
    }
  }

  return (
    <div className="space-y-3 max-w-3xl">
      {items.map((it, i) => (
        <div key={i} className="p-4 bg-white border border-gray-200 rounded-md shadow-sm space-y-2">
          <input
            type="text"
            placeholder="Pergunta / objeção"
            value={it.question}
            onChange={(e) => update(i, "question", e.target.value)}
            readOnly={readOnly}
            className={`w-full px-3 py-2 bg-white border border-gray-300 text-gray-900 rounded text-sm focus:outline-none focus:border-blue-500 placeholder-gray-400 ${readOnly ? "cursor-default bg-gray-50" : ""}`}
          />
          <textarea
            rows={3}
            placeholder="Resposta"
            value={it.answer}
            onChange={(e) => update(i, "answer", e.target.value)}
            readOnly={readOnly}
            className={`w-full px-3 py-2 bg-white border border-gray-300 text-gray-900 rounded text-sm focus:outline-none focus:border-blue-500 placeholder-gray-400 ${readOnly ? "cursor-default bg-gray-50" : ""}`}
          />
          {!readOnly && (
          <button
            type="button"
            onClick={() => remove(i)}
            className="text-sm text-red-500 hover:text-red-700 font-medium transition-colors"
          >
            Remover
          </button>
          )}
        </div>
      ))}
      {!readOnly && (
      <button
        type="button"
        onClick={add}
        className="w-full py-3 border-2 border-dashed border-gray-300 text-gray-500 hover:border-blue-400 hover:text-blue-600 rounded-md transition-colors"
      >
        + Adicionar
      </button>
      )}
      {!readOnly && (
      <button
        type="button"
        onClick={save}
        className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-md font-medium transition-colors"
      >
        Salvar FAQ
      </button>
      )}
    </div>
  );
}
